import { useTranslation } from "next-i18next";
import React from "react";
import { Heading2 } from "../common/standard/headings/Heading";
import { Separator } from "../ui/separator";

const RiskWarnings = ({ hideSeprator = false }: any) => {
  const { t } = useTranslation("layout");
  return (
    <div className="grid gap-3 p-5 mb-16 text-center text-sm  mx-auto">
      {hideSeprator ? "" : <Separator />}
      <div className="flex text-center w-full justify-center text-2xl">
        {t("footer.riskWarnings.heading")}
      </div>
      <div className="grid text-muted-foreground gap-3">
        <span>{t("warnings.heading1")}</span>
        <span>{t("warnings.heading2")}</span>
        <span>{t("warnings.heading3")}</span>
        <span>{t("warnings.heading4")}</span>
      </div>
    </div>
  );
};

export default RiskWarnings;
